<template>
  <div class="d-flex flex-column flex-column-fluid">
    <!-- شريط الأدوات -->
    <div
      id="kt_app_toolbar"
      class="app-toolbar py-3 py-lg-6 shadow-sm bg-white"
    >
      <div
        id="kt_app_toolbar_container"
        class="app-container container-fluid d-flex flex-stack align-items-center"
      >
        <div
          class="page-title d-flex flex-column justify-content-center flex-wrap me-3"
        >
          <h1 class="page-heading text-dark fw-bold fs-3 my-0">
            <i class="fa fa-calendar-check text-success me-2"></i> كل الأحداث
          </h1>
          <ul
            class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1"
          >
            <li class="breadcrumb-item text-muted">
              <router-link to="/" class="text-muted text-hover-primary">
                <i class="fa fa-home"></i> الصفحة الرئيسية
              </router-link>
            </li>
            <li class="breadcrumb-item">
              <span class="bullet bg-gray-400 w-5px h-2px"></span>
            </li>
            <li class="breadcrumb-item text-muted">الأحداث</li>
          </ul>
        </div>

        <!-- الأزرار -->
        <div class="d-flex gap-2">
          <router-link
            to="/events-favorites"
            class="btn fw-bold text-white"
            style="background-color: #00c444"
          >
            <i class="fa fa-heart me-1 text-white"></i> المفضلات
          </router-link>
          <button
            class="btn fw-bold text-white"
            style="background-color: #00c444"
            @click="openRemindersModal"
          >
            <i class="fa fa-bell me-1 text-white"></i> التذكيرات
          </button>
        </div>
      </div>
    </div>

    <!-- المحتوى -->

    <!-- 🔸 فلاتر البحث -->
    <div class="card mb-5 p-2 shadow-sm border-0">
      <!-- عنوان الفلاتر وزرار البحث -->
      <div
        class="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2"
      >
        <h5 class="fw-bold text-dark mb-0">
          <i class="fa fa-search text-success me-2"></i> البحث عن الأحداث
        </h5>

        <div class="d-flex gap-2 flex-wrap">
          <button
            class="btn btn-outline-success fw-bold btn-sm"
            @click="toggleAdvancedFilters"
          >
            <i
              :class="['fa', showAdvanced ? 'fa-chevron-up' : 'fa-sliders-h']"
              class="me-1"
            ></i>
            {{ showAdvanced ? "إخفاء البحث المتقدم" : "بحث متقدم" }}
          </button>

          <button
            class="btn btn-outline-success fw-bold btn-sm"
            @click="toggleBasicFilters"
          >
            <i
              :class="[
                'fa',
                showBasicSearch ? 'fa-chevron-up' : 'fa-sliders-h',
              ]"
              class="me-1"
            ></i>
            {{ showBasicSearch ? "إخفاء البحث الأساسي" : "بحث أساسي" }}
          </button>
        </div>
      </div>

      <!-- الفلاتر الأساسية -->
      <transition name="fade">
        <div class="row g-3 m-2" v-if="showAdvanced">
          <div
            class="col-6 col-md-3"
            v-for="field in basicFilters"
            :key="field.name"
          >
            <label class="form-label fw-bold small">
              <i :class="field.icon" class="text-success me-1"></i>
              {{ field.label }}
            </label>
            <select
              v-model="filters[field.name]"
              class="form-select form-select-sm shadow-sm"
              @change="applyFilters"
            >
              <option value="">الكل</option>
              <option
                v-for="opt in metadata[field.metaKey]"
                :key="opt.id || opt"
                :value="opt.id || opt"
              >
                {{ opt.name_ar || opt.name || opt.title || opt }}
              </option>
            </select>
          </div>
        </div>
      </transition>

      <!-- الفلاتر المتقدمة -->
      <transition name="fade">
        <div v-if="showBasicSearch" class="advanced-filters mt-4">
          <!-- بطاقة فلاتر التاريخ -->
          <div class="card border-0 shadow-sm mb-4 p-3 rounded-4">
            <h6 class="fw-bold text-success mb-3">
              <i class="fa fa-calendar-alt me-2 text-success"></i> فلاتر التاريخ
            </h6>
            <div class="row g-3">
              <div
                class="col-6 col-md-3"
                v-for="(label, key) in dateFields"
                :key="key"
              >
                <label class="form-label fw-semibold small">{{ label }}</label>
                <input
                  type="date"
                  class="form-control form-control-sm shadow-sm"
                  v-model="filters[key]"
                  @change="applyFilters"
                />
              </div>
            </div>
          </div>

          <!-- بطاقة حالة الحدث -->
          <div class="card border-0 shadow-sm mb-4 p-3 rounded-4">
            <h6 class="fw-bold text-success mb-3">
              <i class="fa fa-toggle-on me-2 text-success"></i> حالة الحدث
            </h6>
            <div class="d-flex flex-wrap gap-3 ps-2">
              <div
                v-for="(label, key) in statusFields"
                :key="key"
                class="form-check form-switch me-4"
              >
                <input
                  type="checkbox"
                  class="form-check-input"
                  :id="key"
                  v-model="filters[key]"
                  @change="applyFilters"
                />
                <label
                  class="form-check-label fw-semibold small ms-1"
                  :for="key"
                  >{{ label }}</label
                >
              </div>
            </div>
          </div>

          <!-- بطاقة الرسوم -->
          <div class="card border-0 shadow-sm mb-4 p-3 rounded-4">
            <h6 class="fw-bold text-success mb-3">
              <i class="fa fa-money-bill-wave me-2 text-success"></i> الرسوم
            </h6>
            <div class="row g-3 align-items-end">
              <div class="col-6 col-md-3">
                <label class="form-label fw-semibold small">الحد الأدنى</label>
                <input
                  type="number"
                  class="form-control form-control-sm shadow-sm"
                  v-model="filters.min_fee"
                  @change="applyFilters"
                />
              </div>
              <div class="col-6 col-md-3">
                <label class="form-label fw-semibold small">الحد الأقصى</label>
                <input
                  type="number"
                  class="form-control form-control-sm shadow-sm"
                  v-model="filters.max_fee"
                  @change="applyFilters"
                />
              </div>
              <div class="col-6 col-md-3">
                <label class="form-label fw-semibold small">العملة</label>
                <input
                  type="text"
                  class="form-control form-control-sm shadow-sm"
                  v-model="filters.currency"
                  placeholder="USD / LYD"
                  @change="applyFilters"
                />
              </div>
              <div class="col-6 col-md-3 d-flex align-items-center mt-3">
                <div class="form-check form-switch">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    id="free_only"
                    v-model="filters.free_only"
                    @change="applyFilters"
                  />
                  <label
                    class="form-check-label fw-semibold small ms-1"
                    for="free_only"
                    >مجانية فقط</label
                  >
                </div>
              </div>
            </div>
          </div>

          <!-- بطاقة المدة -->
          <div class="card border-0 shadow-sm mb-4 p-3 rounded-4">
            <h6 class="fw-bold text-success mb-3">
              <i class="fa fa-hourglass-half me-2 text-success"></i> المدة
            </h6>
            <div class="row g-3">
              <div class="col-6 col-md-3">
                <label class="form-label fw-semibold small"
                  >المدة الدنيا (أيام)</label
                >
                <input
                  type="number"
                  class="form-control form-control-sm shadow-sm"
                  v-model="filters.min_duration"
                  @change="applyFilters"
                />
              </div>
              <div class="col-6 col-md-3">
                <label class="form-label fw-semibold small"
                  >المدة القصوى (أيام)</label
                >
                <input
                  type="number"
                  class="form-control form-control-sm shadow-sm"
                  v-model="filters.max_duration"
                  @change="applyFilters"
                />
              </div>
            </div>
          </div>

          <!-- بطاقة الترتيب -->
          <div class="card border-0 shadow-sm mb-4 p-3 rounded-4">
            <h6 class="fw-bold text-success mb-3">
              <i class="fa fa-sort me-2 text-success"></i> الترتيب
            </h6>
            <div class="row g-3">
              <div class="col-6 col-md-3">
                <label class="form-label fw-semibold small">الترتيب حسب</label>
                <select
                  v-model="filters.sort_by"
                  class="form-select form-select-sm shadow-sm"
                  @change="applyFilters"
                >
                  <option value="">اختر...</option>
                  <option value="start_date">تاريخ البداية</option>
                  <option value="end_date">تاريخ النهاية</option>
                  <option value="fee">الرسوم</option>
                </select>
              </div>
              <div class="col-6 col-md-3">
                <label class="form-label fw-semibold small"
                  >اتجاه الترتيب</label
                >
                <select
                  v-model="filters.sort_order"
                  class="form-select form-select-sm shadow-sm"
                  @change="applyFilters"
                >
                  <option value="">اختر...</option>
                  <option value="asc">تصاعدي</option>
                  <option value="desc">تنازلي</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>

    <!-- تحميل -->
    <div
      v-if="isLoading"
      class="loader text-success text-center p-5"
      style="font-weight: 800; border-radius: 10px; background: #73737326"
    >
      جاري تحميل الأحداث...
      <div class="spinner-border text-success mt-2" role="status"></div>
    </div>

    <!-- عرض الأحداث -->
    <div v-else>
      <div v-if="events.length" class="row g-4 m-1">
        <div
          v-for="event in events"
          :key="event.id"
          class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3 mb-4"
        >
          <div
            class="card event-card h-100 border-0 shadow-sm hover-card cursor-pointer"
            @click="goToEvent(event.id)"
          >
            <div class="event-img-wrapper">
              <img
                :src="getEventImage(event)"
                class="card-img-top event-img"
                alt="صورة الحدث"
                @error="handleImageError"
              />
            </div>
            <div class="card-body p-2 p-md-3">
              <h6 class="card-title fw-bold text-dark mb-1 small">
                <i class="fa fa-bullhorn text-success me-1"></i>
                {{ event.name_ar || event.name }}
              </h6>

              <p class="card-text text-muted smaller mb-1">
                <i class="fa fa-calendar-alt text-success me-1"></i>
                {{ formatDate(event.date?.start) }}
              </p>

              <p
                v-if="event.time?.start"
                class="card-text text-muted smaller mb-1"
              >
                <i class="fa fa-clock text-success me-1"></i>
                {{ event.time.start }}
                <span v-if="event.time.end"> - {{ event.time.end }}</span>
              </p>

              <p
                v-if="event.place && (event.place.city || event.place.country)"
                class="card-text text-muted smaller mb-1"
              >
                <i class="fa fa-map-marker-alt text-danger me-1"></i>
                {{ event.place.city || "" }}
                <span v-if="event.place.country"
                  >، {{ event.place.country }}</span
                >
              </p>

              <div class="text-end mt-2">
                <button class="btn btn-outline-success btn-sm">
                  عرض التفاصيل
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-else class="alert alert-warning text-center mt-5">
        لا توجد أحداث متاحة حالياً.
      </div>

      <nav v-if="meta.last_page" class="mt-3">
        <ul class="pagination justify-content-center">
          <li :class="['page-item', { disabled: !meta.links[0].url }]">
            <a
              class="page-link"
              href="#"
              @click.prevent="goToPage(meta.current_page - 1)"
            >
              &laquo; السابق
            </a>
          </li>

          <li
            v-for="link in meta.links"
            :key="link.label"
            :class="['page-item', { active: link.active }]"
          >
            <a class="page-link" href="#" @click.prevent="goToPage(link.page)">
              <span v-html="link.label"></span>
            </a>
          </li>

          <li :class="['page-item', { disabled: !meta.links[2].url }]">
            <a
              class="page-link"
              href="#"
              @click.prevent="goToPage(meta.current_page + 1)"
            >
              التالي &raquo;
            </a>
          </li>
        </ul>
      </nav>
    </div>
  </div>

  <!-- مودال المفضلات -->
  <div
    class="modal fade favorites-modal"
    id="favoritesModal"
    tabindex="-1"
    aria-labelledby="favoritesModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl modal-dialog-centered">
      <div
        class="modal-content favorites-modal-content rounded-4 shadow-lg border-0"
      >
        <div
          class="modal-header favorites-modal-header text-white rounded-top-4"
        >
          <h5 class="modal-title fw-bold text-white" id="favoritesModalLabel">
            <i class="fa fa-heart me-2 text-white"></i>
            المفضلات الخاصة بي
          </h5>
          <button
            type="button"
            class="btn-close btn-close-white"
            data-bs-dismiss="modal"
            aria-label="إغلاق"
          ></button>
        </div>
        <div class="modal-body favorites-modal-body">
          <!-- التحميل -->
          <div v-if="favoritesLoading" class="text-center p-5">
            <div class="spinner-border text-success mb-2" role="status"></div>
            <p class="text-muted fw-semibold">جاري تحميل المفضلات...</p>
          </div>

          <!-- قائمة المفضلات -->
          <div v-else-if="favorites.length" class="list-group">
            <div
              v-for="fav in favorites"
              :key="fav.id"
              class="list-group-item list-group-item-action mb-3 p-3 rounded-4 shadow-sm d-flex align-items-center favorite-card"
              @click="goToEvent(fav.id)"
            >
              <img
                :src="getEventImage(fav)"
                class="rounded favorite-card-img"
                alt="صورة الحدث"
                @error="handleImageError"
              />
              <div class="flex-grow-1 ms-3">
                <h5 class="fw-bold text-dark mb-2 favorite-card-title">
                  {{ fav.title_ar || fav.title }}
                </h5>
                <p class="mb-1 text-muted favorite-card-date">
                  <i class="fa fa-calendar-alt text-success me-1"></i>
                  {{ formatDate(fav.start_date) }}
                </p>
                <p
                  class="mb-0 text-muted favorite-card-location"
                  v-if="fav.city || fav.country"
                >
                  <i class="fa fa-map-marker-alt text-danger me-1"></i>
                  {{ fav.city || "" }}
                  <span v-if="fav.country">، {{ fav.country }}</span>
                </p>
                <div class="mt-2 favorite-card-tags">
                  <span
                    v-for="sub in fav.subcategories || []"
                    :key="sub.id"
                    class="badge favorite-badge me-1"
                    >{{ sub.title }}</span
                  >
                </div>
              </div>
            </div>
          </div>

          <!-- لا توجد أحداث -->
          <div v-else class="alert alert-warning text-center mt-3">
            لا توجد أحداث في المفضلات بعد.
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- 🟢 مودال التذكيرات -->
  <div
    class="modal fade reminders-modal"
    id="remindersModal"
    tabindex="-1"
    aria-labelledby="remindersModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl modal-dialog-centered">
      <div
        class="modal-content reminders-modal-content rounded-4 shadow-lg border-0"
      >
        <div
          class="modal-header reminders-modal-header text-white rounded-top-4"
        >
          <h5 class="modal-title fw-bold text-white" id="remindersModalLabel">
            <i class="fa fa-bell me-2 text-white"></i>
            تذكيراتي
          </h5>
          <button
            type="button"
            class="btn-close btn-close-white"
            data-bs-dismiss="modal"
            aria-label="إغلاق"
          ></button>
        </div>

        <div class="modal-body reminders-modal-body">
          <div v-if="remindersLoading" class="text-center p-5">
            <div class="spinner-border text-success mb-2" role="status"></div>
            <p class="text-muted fw-semibold">جارٍ تحميل التذكيرات...</p>
          </div>

          <div v-else-if="reminders.length" class="reminders-list">
            <div
              v-for="reminder in reminders"
              :key="reminder.id"
              class="reminder-card mb-3 p-3 rounded-4 shadow-sm cursor-pointer"
              @click="goToEvent(reminder.event.id)"
            >
              <div class="row g-0 align-items-center">
                <div
                  class="col-md-3 d-flex align-items-center justify-content-center p-2"
                >
                  <img
                    :src="getEventImage(reminder.event)"
                    class="img-fluid rounded-3 reminder-img"
                    alt="Event Image"
                  />
                </div>
                <div class="col-md-9">
                  <div class="reminder-body p-2">
                    <h5 class="reminder-title fw-bold text-success mb-2">
                      {{ reminder.event.title_ar || reminder.event.title }}
                    </h5>
                    <p class="mb-1 text-muted">
                      <i class="fas fa-layer-group text-success me-1"></i>
                      عدد الجلسات:
                      <strong>{{ reminder.sessions_count }}</strong>
                    </p>

                    <div
                      v-if="reminder.upcoming_sessions.length"
                      class="mt-3 sessions-box"
                    >
                      <h6 class="fw-bold text-dark mb-2">
                        <i class="fa fa-bullseye text-success me-1"></i>
                        الجلسات القادمة:
                      </h6>
                      <ul class="sessions-list">
                        <li
                          v-for="session in reminder.upcoming_sessions"
                          :key="session.id"
                          class="session-item"
                        >
                          <div class="session-info">
                            <i class="fas fa-clock text-success me-1"></i>
                            <strong>{{ session.title }}</strong> -
                            {{ formatDate(session.date) }}
                            <span class="session-time"
                              >({{ session.start_time }} -
                              {{ session.end_time }})</span
                            >
                          </div>
                          <small class="session-location text-muted">
                            <i
                              class="fas fa-map-marker-alt text-danger me-1"
                            ></i>
                            {{ session.location }}
                          </small>
                        </li>
                      </ul>
                    </div>

                    <p class="text-muted mt-3 mb-0 added-date">
                      <i class="fas fa-calendar-plus text-success me-1"></i>
                      أُضيف في: {{ formatDate(reminder.created_at) }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-else class="empty-state text-center py-5">
            <i class="fa fa-bell-slash empty-icon"></i>
            <p class="empty-text mt-3">لا توجد تذكيرات حالياً</p>
          </div>
        </div>

        <div class="modal-footer reminders-modal-footer">
          <button
            type="button"
            class="btn btn-secondary btn-pill"
            data-bs-dismiss="modal"
          >
            <i class="fa fa-times me-1"></i> إغلاق
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiUrl } from "@/utils/api";

export default {
  name: "AllEvents",
  data() {
    return {
      showAdvanced: false,
      showBasicSearch: false,
      events: [],
      currentPage: 1,
      isLoading: false,
      favorites: [],
      reminders: [],
      token: localStorage.getItem("access_token"),

      isLoading: true,
      favoritesLoading: false,
      remindersLoading: false,
      meta: {}, // لتخزين بيانات pagination من السيرفر
      metadata: {
        countries: [],
        cities: [],
        categories: [],
        subcategories: [],
        sponsors: [],
        types: [],
        levels: [],
        modes: [],
        statuses: [],
        organizations: [],
      },
      filters: {
        country: "",
        city: "",
        category_id: "",
        subcategory_id: "",
        sponsor_id: "",
        type: "",
        level: "",
        mode: "",
        status: "",
        organization: "",
        start_date_from: "",
        start_date_to: "",
        end_date_from: "",
        end_date_to: "",
        deadline_after: "",
        deadline_before: "",
        month: "",
        year: "",
        happening_now: false,
        upcoming_only: false,
        accepting_registration: false,
        min_fee: "",
        max_fee: "",
        free_only: false,
        currency: "",
        min_duration: "",
        max_duration: "",
        sort_by: "",
        sort_order: "",
      },
      isLoading: true,
      defaultImage: "/assets/img/acad-icon.png",
      basicFilters: [
        {
          name: "country",
          label: "الدولة",
          metaKey: "countries",
          icon: "fa fa-flag",
        },
        {
          name: "city",
          label: "المدينة",
          metaKey: "cities",
          icon: "fa fa-city",
        },
        {
          name: "category_id",
          label: "الفئة",
          metaKey: "categories",
          icon: "fa fa-tags",
        },
        {
          name: "subcategory_id",
          label: "الفئة الفرعية",
          metaKey: "subcategories",
          icon: "fa fa-list",
        },
        {
          name: "sponsor_id",
          label: "الراعي",
          metaKey: "sponsors",
          icon: "fa fa-handshake",
        },
        {
          name: "type",
          label: "النوع",
          metaKey: "types",
          icon: "fa fa-shapes",
        },
        {
          name: "level",
          label: "المستوى",
          metaKey: "levels",
          icon: "fa fa-signal",
        },
        {
          name: "mode",
          label: "النمط",
          metaKey: "modes",
          icon: "fa fa-laptop",
        },
        {
          name: "status",
          label: "الحالة",
          metaKey: "statuses",
          icon: "fa fa-info-circle",
        },
        {
          name: "organization",
          label: "المنظمة",
          metaKey: "organizations",
          icon: "fa fa-building",
        },
      ],
      dateFields: {
        start_date_from: "تاريخ البداية من",
        start_date_to: "تاريخ البداية إلى",
        end_date_from: "تاريخ النهاية من",
        end_date_to: "تاريخ النهاية إلى",
        deadline_after: "آخر موعد بعد",
        deadline_before: "آخر موعد قبل",
      },
      statusFields: {
        happening_now: "جارية الآن",
        upcoming_only: "قادمة فقط",
        accepting_registration: "تقبل التسجيل",
      },
    };
  },
  methods: {
    async fetchMetadata() {
      try {
        const response = await fetch(`${apiUrl}/events/filters/metadata`);
        const rdata = await response.json();
        this.metadata = rdata.data;
      } catch (error) {
        console.error("Error fetching metadata:", error);
      }
    },
    async fetchEvents(page = 1) {
      this.isLoading = true;
      try {
        const queryObj = {
          ...this.filters,
          page, // أرسل رقم الصفحة ضمن الفلتر
        };

        const query = new URLSearchParams(
          Object.fromEntries(
            Object.entries(queryObj).filter(([_, v]) => v !== "" && v !== false)
          )
        ).toString();

        const response = await fetch(`${apiUrl}/events?${query}`, {
          headers: { "x-country-code": window.appRegion?.phone_code || "LY" },
        });

        const res = await response.json();
        this.events = res.data || [];
        this.meta = res.meta || {};
        this.currentPage = res.meta?.current_page || 1;
      } catch (error) {
        console.error("Error fetching events:", error);
      } finally {
        this.isLoading = false;
      }
    },

    goToPage(page) {
      if (page && page !== this.currentPage) {
        this.fetchEvents(page);
      }
    },
    applyFilters() {
      this.fetchEvents();
    },
    toggleAdvancedFilters() {
      this.showAdvanced = !this.showAdvanced;
      if (this.showAdvanced) {
        this.showBasicSearch = false;
      }
    },
    toggleBasicFilters() {
      this.showBasicSearch = !this.showBasicSearch;
      if (this.showBasicSearch) {
        this.showAdvanced = false;
      }
    },
    async fetchFavorites() {
      if (!this.token) return (this.favorites = []);
      this.favoritesLoading = true;
      try {
        const response = await fetch(`${apiUrl}/favorites/events?per_page=12`, {
          headers: { Authorization: `Bearer ${this.token}` },
        });
        const res = await response.json();
        this.favorites = res.data || [];
      } catch (error) {
        console.error("Error fetching favorites:", error);
      } finally {
        this.favoritesLoading = false;
      }
    },

    async fetchReminders() {
      if (!this.token) return (this.reminders = []);
      this.remindersLoading = true;
      try {
        const response = await fetch(`${apiUrl}/reminders/events`, {
          headers: { Authorization: `Bearer ${this.token}` },
        });
        const res = await response.json();
        this.reminders = res.data || [];
      } catch (error) {
        console.error("Error fetching reminders:", error);
      } finally {
        this.remindersLoading = false;
      }
    },
    openFavoritesModal() {
      const modal = new bootstrap.Modal(
        document.getElementById("favoritesModal")
      );
      modal.show();
      this.fetchFavorites();
    },
    openRemindersModal() {
      const modal = new bootstrap.Modal(
        document.getElementById("remindersModal")
      );
      modal.show();
      this.fetchReminders();
    },
    getEventImage(event) {
      if (!event?.image) return this.defaultImage;
      return event.image.startsWith("http")
        ? event.image
        : `${apiUrl}${event.image}`;
    },
    handleImageError(e) {
      e.target.src = this.defaultImage;
    },
    formatDate(dateString) {
      if (!dateString) return "غير محدد";
      const date = new Date(dateString);
      return date.toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    },
    goToEvent(id) {
      window.location.href = `/event-details?id=${id}`;
    },
  },
  async mounted() {
    await this.fetchMetadata();
    await this.fetchEvents();
  },
};
</script>

<style scoped>
/* ========== Buttons ========== */
.btn-outline-success {
  border: 2px solid #00c444 !important;
  color: #00c444 !important;
  background: transparent;
  font-weight: 600;
  border-radius: 12px;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}
.btn-outline-success::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(0, 196, 68, 0.1),
    transparent
  );
  transition: left 0.5s ease;
}
.btn-outline-success:hover::before {
  left: 100%;
}
.btn-outline-success:hover {
  background: linear-gradient(135deg, #00c444 0%, #00a43c 100%) !important;
  color: #fff !important;
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 196, 68, 0.3);
  border-color: transparent !important;
}
.btn-success {
  background: linear-gradient(135deg, #00c444 0%, #00a43c 100%) !important;
  border: none !important;
  border-radius: 12px;
  box-shadow: 0 4px 15px rgba(0, 196, 68, 0.3);
  transition: all 0.3s ease;
}
.btn-success:hover {
  background: linear-gradient(135deg, #00d44a 0%, #00b844 100%) !important;
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 196, 68, 0.4);
}
.text-success {
  color: #00c444 !important;
}

/* ========== Toolbar ========== */
#kt_app_toolbar {
  background: linear-gradient(135deg, #ffffff 0%, #f8fffe 100%) !important;
  border-bottom: 1px solid rgba(0, 196, 68, 0.1);
}
.page-heading {
  background: linear-gradient(135deg, #00c444 0%, #00a43c 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* ========== Filter Card ========== */
.card.mb-5.p-2 {
  border-radius: 24px !important;
  background: linear-gradient(145deg, #ffffff 0%, #f8fffe 100%);
  border: 1px solid rgba(0, 196, 68, 0.1) !important;
  box-shadow: 0 8px 32px rgba(0, 196, 68, 0.08) !important;
  padding: 20px !important;
  position: relative;
  overflow: hidden;
}
.card.mb-5.p-2::before {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  width: 200px;
  height: 200px;
  background: radial-gradient(
    circle,
    rgba(0, 196, 68, 0.05) 0%,
    transparent 70%
  );
  border-radius: 50%;
  transform: translate(30%, -30%);
  pointer-events: none;
}

/* ========== Event Cards ========== */
.event-card {
  border-radius: 20px !important;
  overflow: hidden;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  background: linear-gradient(145deg, #ffffff 0%, #fafffe 100%);
  border: 1px solid rgba(0, 196, 68, 0.08) !important;
  position: relative;
}
.event-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #00c444, #00e050, #00c444);
  background-size: 200% 100%;
  opacity: 0;
  transition: opacity 0.3s ease;
  z-index: 10;
}
.event-card:hover::before {
  opacity: 1;
  animation: gradientSlide 2s linear infinite;
}
@keyframes gradientSlide {
  0% {
    background-position: 0% 50%;
  }
  100% {
    background-position: 200% 50%;
  }
}
.event-card:hover {
  transform: translateY(-12px) scale(1.02);
  box-shadow: 0 25px 50px rgba(0, 196, 68, 0.18),
    0 10px 20px rgba(0, 0, 0, 0.08) !important;
  border-color: rgba(0, 196, 68, 0.2) !important;
}

.event-img-wrapper {
  width: 100%;
  height: 180px;
  overflow: hidden;
  position: relative;
}
.event-img-wrapper::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 60px;
  background: linear-gradient(180deg, transparent 0%, rgba(0, 0, 0, 0.3) 100%);
  opacity: 0;
  transition: opacity 0.3s ease;
}
.event-card:hover .event-img-wrapper::after {
  opacity: 1;
}

.event-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: all 0.5s ease;
}
.event-card:hover .event-img {
  transform: scale(1.1);
  filter: brightness(1.05);
}

.event-card .card-body {
  padding: 16px;
}
.event-card .card-title {
  font-size: 0.95rem;
  font-weight: 700;
  color: #1a1a2e;
  line-height: 1.4;
  margin-bottom: 10px;
  transition: color 0.3s ease;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.event-card:hover .card-title {
  color: #00a43c;
}
.event-card .card-text {
  color: #666;
  font-size: 0.8rem;
}

/* ========== Hover Card ========== */
.hover-card {
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  cursor: pointer;
}

/* ========== Transitions ========== */
.fade-enter-active,
.fade-leave-active {
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

/* ========== Advanced Filters ========== */
.advanced-filters .card {
  background: linear-gradient(145deg, #f8fffe 0%, #f0fff5 100%);
  border: none !important;
  border-radius: 20px !important;
  border-left: 4px solid #00c444 !important;
  box-shadow: 0 4px 20px rgba(0, 196, 68, 0.08);
}
.advanced-filters h6 {
  font-size: 1rem;
}

/* ========== Form Controls ========== */
.form-select,
.form-control {
  border-radius: 12px;
  border: 1.5px solid #e8f5ed;
  padding: 10px 14px;
  transition: all 0.3s ease;
  background-color: #fafffe;
}
.form-select:focus,
.form-control:focus {
  border-color: #00c444;
  box-shadow: 0 0 0 4px rgba(0, 196, 68, 0.12);
  background-color: #fff;
}
.form-select:hover,
.form-control:hover {
  border-color: rgba(0, 196, 68, 0.4);
}
.form-label {
  color: #2d3748;
  font-weight: 600;
  margin-bottom: 6px;
}
.form-check-input:checked {
  background-color: #00c444 !important;
  border-color: #00c444 !important;
  box-shadow: 0 2px 8px rgba(0, 196, 68, 0.3);
}

/* ========== Loader ========== */
.loader {
  border-radius: 20px !important;
  background: linear-gradient(145deg, #f8fffe 0%, #f0fff5 100%) !important;
  border: 1px solid rgba(0, 196, 68, 0.1);
  animation: loaderPulse 1.5s ease-in-out infinite;
}
@keyframes loaderPulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.7;
  }
}

/* ========== Pagination ========== */
.pagination .page-link {
  border-radius: 10px;
  margin: 0 4px;
  border: 1px solid rgba(0, 196, 68, 0.2);
  color: #00c444;
  transition: all 0.3s ease;
}
.pagination .page-link:hover {
  background: linear-gradient(135deg, #e8fff1 0%, #d4f7e2 100%);
  border-color: #00c444;
  transform: translateY(-2px);
}
.pagination .page-item.active .page-link {
  background: linear-gradient(135deg, #00c444 0%, #00a43c 100%);
  border-color: transparent;
  box-shadow: 0 4px 15px rgba(0, 196, 68, 0.3);
}

/* ========== Favorites Modal ========== */
.favorites-modal .favorites-modal-content {
  border-radius: 24px;
  overflow: hidden;
  border: none;
}
.favorites-modal-header {
  background: linear-gradient(135deg, #00c444 0%, #00a43c 100%);
  font-size: 1.1rem;
  padding: 20px 24px;
}
.favorites-modal-body {
  background: linear-gradient(145deg, #f8fffe 0%, #ffffff 100%);
  padding: 24px;
}

.favorite-card {
  cursor: pointer;
  transition: all 0.3s ease;
  background: linear-gradient(145deg, #ffffff 0%, #fafffe 100%);
  border: 1px solid rgba(0, 196, 68, 0.1) !important;
  border-radius: 16px !important;
}
.favorite-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 10px 30px rgba(0, 196, 68, 0.15) !important;
  border-color: rgba(0, 196, 68, 0.25) !important;
}

.favorite-card-img {
  width: 100px;
  height: 100px;
  object-fit: cover;
  flex-shrink: 0;
  border-radius: 12px;
  border: 2px solid rgba(0, 196, 68, 0.15);
}

.favorite-card-title {
  font-size: 1rem;
  color: #1a1a2e;
}

.favorite-card-date,
.favorite-card-location {
  font-size: 0.85rem;
}

.favorite-badge {
  background: linear-gradient(135deg, #00c444 0%, #00a43c 100%);
  color: #fff;
  font-size: 0.75rem;
  padding: 4px 10px;
  border-radius: 999px;
  box-shadow: 0 2px 8px rgba(0, 196, 68, 0.25);
}

/* ========== Reminders Modal ========== */
.reminders-modal .reminders-modal-content {
  border-radius: 24px;
  overflow: hidden;
  border: none;
  box-shadow: 0 25px 80px rgba(0, 0, 0, 0.15);
}
.reminders-modal-header {
  background: linear-gradient(135deg, #00c444 0%, #00a43c 100%);
  padding: 20px 24px;
  border: none;
}
.reminders-modal-header .modal-title {
  font-size: 1.2rem;
  display: flex;
  align-items: center;
}
.reminders-modal-header .modal-title i {
  font-size: 1.3rem;
  animation: bellRing 2s ease-in-out infinite;
}
@keyframes bellRing {
  0%,
  100% {
    transform: rotate(0);
  }
  10%,
  30% {
    transform: rotate(10deg);
  }
  20%,
  40% {
    transform: rotate(-10deg);
  }
  50% {
    transform: rotate(0);
  }
}
.reminders-modal-body {
  background: linear-gradient(145deg, #f8fffe 0%, #ffffff 100%);
  padding: 24px;
  max-height: 70vh;
  overflow-y: auto;
}
.reminders-modal-footer {
  background: linear-gradient(145deg, #f8fffe 0%, #ffffff 100%);
  border-top: 1px solid rgba(0, 196, 68, 0.1);
  padding: 16px 24px;
}
.reminders-modal-footer .btn-pill {
  border-radius: 999px;
  padding: 10px 24px;
  font-weight: 600;
}

/* Reminder Card */
.reminder-card {
  background: linear-gradient(145deg, #ffffff 0%, #fafffe 100%);
  border: 1px solid rgba(0, 196, 68, 0.1);
  border-radius: 20px !important;
  transition: all 0.3s ease;
  overflow: hidden;
}
.reminder-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 30px rgba(0, 196, 68, 0.12) !important;
  border-color: rgba(0, 196, 68, 0.25);
}
.reminder-img {
  max-height: 140px;
  width: 100%;
  object-fit: cover;
  border-radius: 16px;
  border: 2px solid rgba(0, 196, 68, 0.15);
  transition: all 0.3s ease;
}
.reminder-card:hover .reminder-img {
  transform: scale(1.03);
}
.reminder-title {
  font-size: 1.1rem;
  color: #00a43c !important;
}
.sessions-box {
  background: linear-gradient(145deg, #f0fff5 0%, #e8fff1 100%);
  border-radius: 14px;
  padding: 14px;
  border-left: 4px solid #00c444;
}
.sessions-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.session-item {
  padding: 10px 0;
  border-bottom: 1px dashed rgba(0, 196, 68, 0.2);
}
.session-item:last-child {
  border-bottom: none;
}
.session-info {
  font-size: 0.9rem;
  color: #1a1a2e;
}
.session-time {
  color: #00c444;
  font-weight: 600;
}
.session-location {
  display: block;
  margin-top: 4px;
  font-size: 0.8rem;
}
.added-date {
  font-size: 0.85rem;
  padding-top: 10px;
  border-top: 1px solid rgba(0, 196, 68, 0.1);
}

/* Empty State */
.empty-state {
  padding: 60px 20px;
}
.empty-icon {
  font-size: 4rem;
  color: rgba(0, 196, 68, 0.3);
  display: block;
}
.empty-text {
  color: #666;
  font-size: 1.1rem;
  font-weight: 500;
}

/* Favorites Modal Enhanced */
.favorites-modal .favorites-modal-content {
  box-shadow: 0 25px 80px rgba(0, 0, 0, 0.15);
}
.favorites-modal-header {
  padding: 20px 24px;
}
.favorites-modal-header .modal-title {
  font-size: 1.2rem;
  display: flex;
  align-items: center;
}
.favorites-modal-header .modal-title i {
  animation: heartBeat 1.5s ease-in-out infinite;
}
@keyframes heartBeat {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.15);
  }
}
.favorites-modal-body {
  max-height: 70vh;
  overflow-y: auto;
}
.favorite-card {
  position: relative;
  overflow: hidden;
}
.favorite-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 4px;
  height: 100%;
  background: linear-gradient(180deg, #00c444 0%, #00e050 100%);
  opacity: 0;
  transition: opacity 0.3s ease;
}
.favorite-card:hover::before {
  opacity: 1;
}

/* ========== Alert ========== */
.alert-warning {
  border-radius: 16px;
  border: none;
  background: linear-gradient(135deg, #fff8e6 0%, #fff3d4 100%);
  box-shadow: 0 4px 20px rgba(255, 193, 7, 0.15);
}

/* ========== Grid Animation ========== */
.row.g-4 > div {
  animation: cardFadeIn 0.5s ease forwards;
  opacity: 0;
}
.row.g-4 > div:nth-child(1) {
  animation-delay: 0.05s;
}
.row.g-4 > div:nth-child(2) {
  animation-delay: 0.1s;
}
.row.g-4 > div:nth-child(3) {
  animation-delay: 0.15s;
}
.row.g-4 > div:nth-child(4) {
  animation-delay: 0.2s;
}
.row.g-4 > div:nth-child(5) {
  animation-delay: 0.25s;
}
.row.g-4 > div:nth-child(6) {
  animation-delay: 0.3s;
}
.row.g-4 > div:nth-child(7) {
  animation-delay: 0.35s;
}
.row.g-4 > div:nth-child(8) {
  animation-delay: 0.4s;
}
@keyframes cardFadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.small {
  font-size: 0.85rem;
}

.smaller {
  font-size: 0.75rem;
}

.cursor-pointer {
  cursor: pointer;
}

/* ========== Responsive ========== */
@media (max-width: 768px) {
  .advanced-filters .card {
    padding: 1rem !important;
  }
  .form-label {
    font-size: 0.85rem;
  }
  .event-card {
    border-radius: 16px !important;
  }
  .event-img-wrapper {
    height: 160px;
  }
  .card.mb-5.p-2 {
    padding: 16px !important;
    border-radius: 18px !important;
  }
  .favorite-card {
    flex-direction: column;
    align-items: flex-start;
  }
  .favorite-card-img {
    width: 100%;
    height: 180px;
    margin-bottom: 0.5rem;
  }
  .favorite-card-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 0.25rem;
  }
}

@media (max-width: 576px) {
  .event-card {
    font-size: 0.85rem;
  }
  .event-img-wrapper {
    height: 140px;
  }
}

/* ========== Scrollbar ========== */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
::-webkit-scrollbar-track {
  background: #f0fff5;
  border-radius: 10px;
}
::-webkit-scrollbar-thumb {
  background: linear-gradient(180deg, #00c444 0%, #00a43c 100%);
  border-radius: 10px;
}
::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(180deg, #00d44a 0%, #00b844 100%);
}

/* ========== DARK MODE ========== */
[data-bs-theme="dark"] #kt_app_toolbar,
[data-theme="dark"] #kt_app_toolbar,
.dark #kt_app_toolbar {
  background: linear-gradient(135deg, #1a1b1d 0%, #242526 100%) !important;
  border-color: rgba(0, 196, 68, 0.15);
}

[data-bs-theme="dark"] .page-heading,
[data-theme="dark"] .page-heading,
.dark .page-heading {
  background: linear-gradient(135deg, #00e050 0%, #00c444 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

[data-bs-theme="dark"] .card.mb-5.p-2,
[data-theme="dark"] .card.mb-5.p-2,
.dark .card.mb-5.p-2 {
  background: linear-gradient(145deg, #242526 0%, #1a1b1d 100%);
  border-color: rgba(0, 196, 68, 0.15) !important;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4) !important;
}
[data-bs-theme="dark"] .card.mb-5.p-2::before,
[data-theme="dark"] .card.mb-5.p-2::before,
.dark .card.mb-5.p-2::before {
  background: radial-gradient(
    circle,
    rgba(0, 196, 68, 0.1) 0%,
    transparent 70%
  );
}
[data-bs-theme="dark"] .card.mb-5.p-2 h5,
[data-theme="dark"] .card.mb-5.p-2 h5,
.dark .card.mb-5.p-2 h5 {
  color: #e4e6eb;
}

[data-bs-theme="dark"] .event-card,
[data-theme="dark"] .event-card,
.dark .event-card {
  background: linear-gradient(145deg, #242526 0%, #1a1b1d 100%);
  border-color: rgba(0, 196, 68, 0.15) !important;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
}
[data-bs-theme="dark"] .event-card:hover,
[data-theme="dark"] .event-card:hover,
.dark .event-card:hover {
  box-shadow: 0 25px 50px rgba(0, 196, 68, 0.2), 0 10px 20px rgba(0, 0, 0, 0.4) !important;
  border-color: rgba(0, 196, 68, 0.3) !important;
}
[data-bs-theme="dark"] .event-card .card-title,
[data-theme="dark"] .event-card .card-title,
.dark .event-card .card-title {
  color: #e4e6eb;
}
[data-bs-theme="dark"] .event-card:hover .card-title,
[data-theme="dark"] .event-card:hover .card-title,
.dark .event-card:hover .card-title {
  color: #00e050;
}
[data-bs-theme="dark"] .event-card .card-text,
[data-theme="dark"] .event-card .card-text,
.dark .event-card .card-text {
  color: #b0b3b8;
}

[data-bs-theme="dark"] .advanced-filters .card,
[data-theme="dark"] .advanced-filters .card,
.dark .advanced-filters .card {
  background: linear-gradient(145deg, #2d2e30 0%, #242526 100%);
  border-left-color: #00c444 !important;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
}
[data-bs-theme="dark"] .advanced-filters h6,
[data-theme="dark"] .advanced-filters h6,
.dark .advanced-filters h6 {
  color: #00e050;
}

[data-bs-theme="dark"] .form-select,
[data-bs-theme="dark"] .form-control,
[data-bs-theme="dark"] input[type="text"],
[data-bs-theme="dark"] input[type="number"],
[data-bs-theme="dark"] input[type="date"],
[data-bs-theme="dark"] select,
[data-theme="dark"] .form-select,
[data-theme="dark"] .form-control,
[data-theme="dark"] input[type="text"],
[data-theme="dark"] input[type="number"],
[data-theme="dark"] input[type="date"],
[data-theme="dark"] select,
.dark .form-select,
.dark .form-control,
.dark input[type="text"],
.dark input[type="number"],
.dark input[type="date"],
.dark select {
  background-color: #3a3b3d !important;
  border-color: rgba(0, 196, 68, 0.2) !important;
  color: #e4e6eb !important;
}
[data-bs-theme="dark"] .form-select:focus,
[data-bs-theme="dark"] .form-control:focus,
[data-theme="dark"] .form-select:focus,
[data-theme="dark"] .form-control:focus,
.dark .form-select:focus,
.dark .form-control:focus {
  background-color: #3a3b3d !important;
  border-color: #00c444 !important;
  box-shadow: 0 0 0 4px rgba(0, 196, 68, 0.15) !important;
}
[data-bs-theme="dark"] .form-select,
[data-theme="dark"] .form-select,
.dark .form-select {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%2300e050' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e") !important;
}
[data-bs-theme="dark"] input::placeholder,
[data-theme="dark"] input::placeholder,
.dark input::placeholder {
  color: #8b8d91 !important;
}
[data-bs-theme="dark"] .form-label,
[data-theme="dark"] .form-label,
.dark .form-label {
  color: #b0b3b8 !important;
}
[data-bs-theme="dark"] .form-check-label,
[data-theme="dark"] .form-check-label,
.dark .form-check-label {
  color: #b0b3b8 !important;
}

[data-bs-theme="dark"] .loader,
[data-theme="dark"] .loader,
.dark .loader {
  background: linear-gradient(145deg, #242526 0%, #1a1b1d 100%) !important;
  border-color: rgba(0, 196, 68, 0.15);
  color: #00e050 !important;
}

[data-bs-theme="dark"] .pagination .page-link,
[data-theme="dark"] .pagination .page-link,
.dark .pagination .page-link {
  background: #242526;
  border-color: rgba(0, 196, 68, 0.2);
  color: #00e050;
}
[data-bs-theme="dark"] .pagination .page-link:hover,
[data-theme="dark"] .pagination .page-link:hover,
.dark .pagination .page-link:hover {
  background: linear-gradient(135deg, #1a3d2a 0%, #1e4d35 100%);
}

[data-bs-theme="dark"] .favorites-modal-body,
[data-theme="dark"] .favorites-modal-body,
.dark .favorites-modal-body {
  background: linear-gradient(145deg, #1a1b1d 0%, #242526 100%);
}
[data-bs-theme="dark"] .favorite-card,
[data-theme="dark"] .favorite-card,
.dark .favorite-card {
  background: linear-gradient(145deg, #242526 0%, #1a1b1d 100%);
  border-color: rgba(0, 196, 68, 0.15) !important;
}
[data-bs-theme="dark"] .favorite-card:hover,
[data-theme="dark"] .favorite-card:hover,
.dark .favorite-card:hover {
  box-shadow: 0 10px 30px rgba(0, 196, 68, 0.2) !important;
}
[data-bs-theme="dark"] .favorite-card-title,
[data-theme="dark"] .favorite-card-title,
.dark .favorite-card-title {
  color: #e4e6eb;
}
[data-bs-theme="dark"] .favorite-card-date,
[data-bs-theme="dark"] .favorite-card-location,
[data-theme="dark"] .favorite-card-date,
[data-theme="dark"] .favorite-card-location,
.dark .favorite-card-date,
.dark .favorite-card-location {
  color: #b0b3b8 !important;
}

/* Reminders Modal Dark Mode */
[data-bs-theme="dark"] .reminders-modal-body,
[data-theme="dark"] .reminders-modal-body,
.dark .reminders-modal-body {
  background: linear-gradient(145deg, #1a1b1d 0%, #242526 100%);
}
[data-bs-theme="dark"] .reminders-modal-footer,
[data-theme="dark"] .reminders-modal-footer,
.dark .reminders-modal-footer {
  background: linear-gradient(145deg, #1a1b1d 0%, #242526 100%);
  border-color: rgba(0, 196, 68, 0.15);
}
[data-bs-theme="dark"] .reminder-card,
[data-theme="dark"] .reminder-card,
.dark .reminder-card {
  background: linear-gradient(145deg, #242526 0%, #1a1b1d 100%);
  border-color: rgba(0, 196, 68, 0.15) !important;
}
[data-bs-theme="dark"] .reminder-card:hover,
[data-theme="dark"] .reminder-card:hover,
.dark .reminder-card:hover {
  box-shadow: 0 12px 30px rgba(0, 196, 68, 0.2) !important;
}
[data-bs-theme="dark"] .reminder-title,
[data-theme="dark"] .reminder-title,
.dark .reminder-title {
  color: #00e050 !important;
}
[data-bs-theme="dark"] .sessions-box,
[data-theme="dark"] .sessions-box,
.dark .sessions-box {
  background: linear-gradient(145deg, #1a3d2a 0%, #1e4d35 100%);
  border-left-color: #00e050;
}
[data-bs-theme="dark"] .sessions-box h6,
[data-theme="dark"] .sessions-box h6,
.dark .sessions-box h6 {
  color: #e4e6eb !important;
}
[data-bs-theme="dark"] .session-info,
[data-theme="dark"] .session-info,
.dark .session-info {
  color: #e4e6eb;
}
[data-bs-theme="dark"] .session-item,
[data-theme="dark"] .session-item,
.dark .session-item {
  border-color: rgba(0, 196, 68, 0.2);
}
[data-bs-theme="dark"] .added-date,
[data-theme="dark"] .added-date,
.dark .added-date {
  border-color: rgba(0, 196, 68, 0.15);
}
[data-bs-theme="dark"] .empty-icon,
[data-theme="dark"] .empty-icon,
.dark .empty-icon {
  color: rgba(0, 196, 68, 0.4);
}
[data-bs-theme="dark"] .empty-text,
[data-theme="dark"] .empty-text,
.dark .empty-text {
  color: #b0b3b8;
}

[data-bs-theme="dark"] .modal-body.bg-light,
[data-theme="dark"] .modal-body.bg-light,
.dark .modal-body.bg-light {
  background: linear-gradient(145deg, #1a1b1d 0%, #242526 100%) !important;
}
[data-bs-theme="dark"] .modal-content,
[data-theme="dark"] .modal-content,
.dark .modal-content {
  background: #242526;
  border-color: rgba(0, 196, 68, 0.15);
}

[data-bs-theme="dark"] .alert-warning,
[data-theme="dark"] .alert-warning,
.dark .alert-warning {
  background: linear-gradient(135deg, #3d3520 0%, #4a3f1a 100%);
  color: #ffd666;
}

[data-bs-theme="dark"] .breadcrumb-item.text-muted,
[data-theme="dark"] .breadcrumb-item.text-muted,
.dark .breadcrumb-item.text-muted {
  color: #b0b3b8 !important;
}
[data-bs-theme="dark"] .breadcrumb-item a,
[data-theme="dark"] .breadcrumb-item a,
.dark .breadcrumb-item a {
  color: #00e050 !important;
}

[data-bs-theme="dark"] .btn-outline-success,
[data-theme="dark"] .btn-outline-success,
.dark .btn-outline-success {
  border-color: #00e050 !important;
  color: #00e050 !important;
}
[data-bs-theme="dark"] .btn-outline-success:hover,
[data-theme="dark"] .btn-outline-success:hover,
.dark .btn-outline-success:hover {
  background: linear-gradient(135deg, #00c444 0%, #00a43c 100%) !important;
  color: #fff !important;
}

[data-bs-theme="dark"] ::-webkit-scrollbar-track,
[data-theme="dark"] ::-webkit-scrollbar-track,
.dark ::-webkit-scrollbar-track {
  background: #242526;
}
</style>
